import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from "./ItemCategory.reducer";

export const selectFeature = createFeatureSelector<State>('ItemCategory');

export const ItemCategorySelector = {
    selectRequestProcessing: createSelector(
        selectFeature,
        (state) => state.requestProcessing
    ),
    selectGetAllItemCategoryRequestProcessing: createSelector(
        selectFeature,
        (state) => state.GetAllItemCategory.requestProcessing
    ),
    selectGetAllItemCategoryCriteria: createSelector(
        selectFeature,
        (state) => state.GetAllItemCategory.criteria
    ),
    selectGetAllItemCategoryResonse: createSelector(
        selectFeature,
        (state) => state.GetAllItemCategory.response
    ),

    selectGetAllCollectionTypeRequestProcessing: createSelector(
        selectFeature,
        (state) => state.GetAllCollectionType.requestProcessing
    ),
    selectGetAllCollectionTypeCriteria: createSelector(
        selectFeature,
        (state) => state.GetAllCollectionType.criteria
    ),
    selectGetAllCollectionTypeResonse: createSelector(
        selectFeature,
        (state) => state.GetAllCollectionType.response
    ),

    selectGetAllProductTypeRequestProcessing: createSelector(
        selectFeature,
        (state) => state.GetAllProductType.requestProcessing
    ),
    selectGetAllProductTypeCriteria: createSelector(
        selectFeature,
        (state) => state.GetAllProductType.criteria
    ),
    selectGetAllProductTypeResonse: createSelector(
        selectFeature,
        (state) => state.GetAllProductType.response
    ),

    selectGetAllOccasionTypeRequestProcessing: createSelector(
        selectFeature,
        (state) => state.GetAllOccasionType.requestProcessing
    ),
    selectGetAllOccasionTypeCriteria: createSelector(
        selectFeature,
        (state) => state.GetAllOccasionType.criteria
    ),
    selectGetAllOccasionTypeResonse: createSelector(
        selectFeature,
        (state) => state.GetAllOccasionType.response
    ),

    selectGetFestiveOccasionNameResponse: createSelector(
        selectFeature,
        (state) => state.GetFestiveOccasionName.response
    ),

    selectGetAllFestiveOccasionItemsRequestProcessing: createSelector(
        selectFeature,
        (state) => state.GetAllFestiveOccasionItems.requestProcessing
    ),
    selectGetAllFestiveOccasionItemsCriteria: createSelector(
        selectFeature,
        (state) => state.GetAllFestiveOccasionItems.criteria
    ),
    selectGetAllFestiveOccasionItemsResonse: createSelector(
        selectFeature,
        (state) => state.GetAllFestiveOccasionItems.response
    ),
};
